import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import { CaseCreationState } from 'app/features/case-creation/case-creation.state';
import { toCaseCreateSuccess, CaseCreateSuccess } from './case-create-success';

export const caseCreateSuccessResolver: ResolveFn<CaseCreateSuccess> = (route) =>
  inject(CaseCreationState).load(route.paramMap.get('caseId')!).pipe(map(toCaseCreateSuccess));
